























































import { defineComponent, computed, toRefs, PropType } from "@vue/composition-api";

import ListFilter from "@/components/Molecules/ListFilter/index.vue";
import FilterSection from "@/components/Molecules/FilterSection/index.vue";
import OccSearchMultiSelectbox from "@/components/Atoms/OccSearchMultiSelectbox/index.vue";
import DateRangeSelector from "@/components/Molecules/DateRangeSelector/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import { ListFilterConditions } from "@/helpers/sponsoredEventEntryApplicants";
import { selectListGenerator } from "@/helpers/partnerEntryUsers";
import { ApiResponse } from "@/api/types";

import type {
  RoundtableAttendeesFilterName,
  RoundtableAttendeesSelectItemList,
  RoundtableAttendeesFilterData
} from "./type"

export default defineComponent({
  components: {
    ListFilter,
    FilterSection,
    OccSearchMultiSelectbox,
    DateRangeSelector,
    SearchTextField
  },
  name: "RoundtableFilter",
  props: {
    value: {
      type: Object as PropType<RoundtableAttendeesFilterData>,
      default: () => ({
        keyword: "",
        universities: [] as string[],
        graduateYears: [] as string[],
        grades: [] as string[],
        schedules: [] as number[],
        event_ids: [] as number[],
        entryDate: { from: "", to: "" }
      })
    },
    searchOptions: {
      type: Object as PropType<ApiResponse.RoundtableAtendeeSearchOptions>,
      default: () => ({})
    }
  },
  emits: ["onResetFilter", "onSubmitFilter"],
  setup(props, { emit }) {
    const { value: filterState } = toRefs(props)

    const currentDateStr = computed<string>(() => {
      return new Date().toISOString().slice(0, 10);
    });

    const scheduleSelectItemList = computed(() => {
      if (!props.searchOptions) {
        return [];
      }

      const tmpSchedulesItemList = (props.searchOptions?.schedules || []).map((v) => {
        return {
          value: v.id,
          label: v.title
        };
      });

      return tmpSchedulesItemList;
    });

    const eventSelectItemList = computed(() => {
      if (!props.searchOptions) {
        return [];
      }

      const tmpEventsItemList = (props.searchOptions?.events || []).map((v) => {
        return {
          value: v.id,
          label: v.title
        };
      });

      return tmpEventsItemList;
    });

    const selectItemList = computed<RoundtableAttendeesSelectItemList>(() => {
      return {
        entryDate: [],
        universities: selectListGenerator(
          props.searchOptions?.universities || []
        ),
        graduateYears: selectListGenerator(
          props.searchOptions?.graduate_years || []
        ),
        grades: selectListGenerator(props.searchOptions?.grades || []),
        event_ids: eventSelectItemList.value,
        schedules: scheduleSelectItemList.value
      };
    });

    const currentFilterCount = computed(() => {
      const currentFilterCount = ListFilterConditions.reduce(
        (preFilterCount: number, condition) => {
          const key: string = condition.name;
          switch (key) {
            case "universities":
            case "graduateYears":
            case "grades":
            case "schedules":
            case "event_ids":
              if (filterState.value[key].length) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            case "entryDate":
              if (filterState.value[key].from || filterState.value[key].to) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            default:
              return preFilterCount;
          }
        },
        0
      );
      return currentFilterCount;
    });

    const handleChangedEntryDateFrom = (value: string) => {
      filterState.value.entryDate.from = value;
    };

    const handleChangedEntryDateTo = (value: string) => {
      filterState.value.entryDate.to = value;
    };

    const onChangeMultiSelect = (
      key: RoundtableAttendeesFilterName,
      newVal: string[] & number[]
    ) => {
      if (key === "entryDate") {
        return;
      }
      filterState.value[key] = newVal;
    };

    const onSearchText = () => {
      emit("onResetFilter", filterState);
    };

    const onResetFilter = () => {
      filterState.value.keyword = "";

      ListFilterConditions.forEach(condition => {
        const key = condition.name;
        switch (key) {
          case "universities":
          case "graduateYears":
          case "grades":
          case "schedules":
          case "event_ids":
            filterState.value[key] = [];
            return;
          case "entryDate":
            filterState.value[key] = { from: "", to: "" };
            return;
        }
      });

      emit("onResetFilter", filterState);
    };

    const onSubmitFilter = () => {
      emit("onSubmitFilter", filterState);
    };

    return {
      listFilterConditions: ListFilterConditions,
      filterState,
      currentDateStr,
      selectItemList,
      currentFilterCount,
      handleChangedEntryDateFrom,
      handleChangedEntryDateTo,
      onChangeMultiSelect,
      onSearchText,
      onResetFilter,
      onSubmitFilter,
    };
  }
});
